<mat-toolbar class="topbar" color="primary">

  <div class="left">
  <button mat-icon-button
  (click)=" collapse()"
  class="collapse" 
  [class.nav-opened] = "!collapsed"
  value="collapsed">
  <i class="fa"
    [class.fa-angle-double-right]="collapsed" 
    [class.fa-angle-double-left]="!collapsed"
  aria-hidden="true"></i>
  </button>

     <div class="titlebar">AdaCAD 4.0, <i>beta</i></div>

     <button mat-icon-button
     (click)="openAboutDialog()"
     matTooltip ="about AdaCAD"
     >
     <i class="fas fa-info-circle"></i>
    </button>
    </div>

    <div class="right">


      <div class="auth" *ngIf="(auth.showLogoutButton)">
        <span class="loggedInUserName">Hi {{auth.username}} </span>
        <a mat-icon-button matTooltip="logout" (click)="logout()"><i class="fa fa-sign-out"></i></a>
      </div>
  </div>



  <!-- <button mat-icon-button
  (click)="drawer.toggle(); collapsed = !collapsed"
  class="collapse" 
  value="collapsed">
  <i class="fa"
    [class.fa-angle-double-right]="collapsed" 
    [class.fa-angle-double-left]="!collapsed"
  aria-hidden="true"></i>
</button> -->


</mat-toolbar>

<div class="betadesc">
  <p>

  This is a new/"beta" release of AdaCAD 4.0. It has more features but has not been tested as extensively as our previous version of AdaCAD.Use at your own risk. 

  <a href="https://adacad.org" class="mat-stroked-button stable" ><i class="fa-solid fa-person-through-window"></i> Take me to the Stable AdaCAD</a>

  <a href="docs.adacad.org" class="mat-stroked-button stable" >
    <i class="fa-solid fa-book-open-reader"></i>Learn More about AdaCAD</a>

    <a href="https://groups.google.com/g/adacad-forum" class="mat-stroked-button stable" >
      <i class="fa-solid fa-spider"></i> Please report any bugs you find</a>
  

    
    <div class="buttonrow">
    
    <div *ngIf="!auth.isLoggedIn">
      <button mat-stroked-button class="example-full-width login" matTooltip="login" (click) = "openLoginDialog()"><i class="fa fa-sign-in"></i> Log in</button>
    </div>

    <div *ngIf="auth.isLoggedIn">
      You are already logged in!
    </div>


    <!-- <a href="http://adacad.org" class="mat-stroked-button" >
      Watch Intro Video
     </a>
      -->
    </div>



</div>


